import { apiFetch } from '../api-client';

export interface ReportsKpi {
  revenue: number;
  cost: number;
  grossProfit: number;
  grossMargin: number;
  preTax: number;
  preTaxMargin: number;
  afterTax: number;
  tax: number;
  cashFlow: number;
}

export interface CtReport {
  summary: {
    totalAmount: number;
    totalTrips: number;
    inQuotaCount: number;
    inQuotaAmount: number;
    overQuotaCount: number;
    overQuotaAmount: number;
  };
  trips: Array<{
    code: string;
    name: string | null;
    place: string | null;
    days: number | null;
    advance: number;
    actual: number | null;
    quota: number | null;
    status: string;
  }>;
}

export interface PLRow { code: string; label: string; cur: number; prev: number; bold?: boolean }
export interface PLReport { year: number; month: number; rows: PLRow[] }

export interface BSItem { code: string; label: string; v: number }
export interface BSSection { code: string; label: string; children: BSItem[]; total: number }
export interface BSReport { year: number; assets: BSSection[]; liabilities: BSSection[]; totalTS: number; totalNV: number; balanced: boolean }

export interface CFRow { section: string; code: string; label: string; cur: number; ytd: number; bold?: boolean }
export interface CFReport { year: number; month: number; rows: CFRow[] }
export interface ConsolidatedReport { year: number; month: number; generatedAt: string; entities: Array<{ id: string; key: string; name: string; department: string; source: 'ledger' | 'mock'; included: boolean }>; pl: Array<PLRow & { software: number; group: number; elimination: number; consolidated: number }>; bs: BSReport; elimination: { source: 'mock'; count: number; amount: number } }

export const reportsApi = {
  kpi: () => apiFetch<ReportsKpi>('/api/reports/kpi'),
  ct: () => apiFetch<CtReport>('/api/reports/ct'),
  pl: (year?: number, month?: number) => {
    const p = new URLSearchParams();
    if (year) p.set('year', String(year));
    if (month) p.set('month', String(month));
    const q = p.toString() ? `?${p.toString()}` : '';
    return apiFetch<PLReport>(`/api/reports/pl${q}`);
  },
  bs: (year?: number) => apiFetch<BSReport>(year ? `/api/reports/bs?year=${year}` : '/api/reports/bs'),
  cf: (year?: number, month?: number) => {
    const p = new URLSearchParams();
    if (year) p.set('year', String(year));
    if (month) p.set('month', String(month));
    const q = p.toString() ? `?${p.toString()}` : '';
    return apiFetch<CFReport>(`/api/reports/cf${q}`);
  },
  consolidated: (year: number, month: number) => apiFetch<ConsolidatedReport>(`/api/reports/consolidated?year=${year}&month=${month}`),
};
